// extracted by css-extract-rspack-plugin
export default {"labelList":"labels-field-module__labelList__gEnY2pf"};